import { IncidentHistoryWebComponent } from './component/IncidentHistoryWebComponent';
import { WEB_COMPONENT_INCIDENT_HISTORY } from '../../webcomponents.constants';

export { IncidentHistoryWebComponent };

window.customElements.define(WEB_COMPONENT_INCIDENT_HISTORY, IncidentHistoryWebComponent);
